import { PersistContext } from "@/data/PersistProvider";
import { useEnhancedHistory } from "@/data/RouterProvider";
import { SendCMD } from "@/utils/HTTPRequest";
import { ChannelRemind } from "@/utils/UrlHelper";
import React, { useEffect } from "react";
import { Dialog } from "react-vant";
import style from "./style.less";

//签到coins数据
const coins_data1 = {
  check_days: [
    {
      checked: true,
      award: 2000,
    },
    {
      checked: true,
      award: 3000,
    },
    {
      checked: true,
      award: 3000,
    },
    {
      checked: false,
      award: 4000,
    },
    {
      checked: false,
      award: 5000,
    },
    {
      checked: false,
      award: 5000,
    },
    {
      checked: false,
      award: 8000,
    },
  ],
  today_checkable: true,
};
const GetCoins = (props) => {
  let history = useEnhancedHistory();

  const { getPersist,setPersist, reloadUserInfo } = React.useContext(PersistContext);

  const userInfo = getPersist("user_info");

  //是否展示签到所得
  const [pLogVisible, setPlogVisible] = React.useState(-1);

  //Get Coins弹框
  const [coinsData, setCoinsData] = React.useState(coins_data1);

  //获取签到coins数据
  const coins_data = () => {
    SendCMD("getCheckIn", { token: userInfo.token }).then((res) => {
      if (res.check_in_data) {
        setCoinsData(res.check_in_data);
      }
    });
  };

  //签到coins请求
  const coins_cmd = () => {
    SendCMD("doCheckIn", { token: userInfo.token }).then((res) => {
      if (res[0].check_success && res[0].check_in_data) {
        setCoinsData(res[0].check_in_data);
        reloadUserInfo();
      }

      //判断最后一次签到获取coins的index
      let activeIndex = -1;
      res[0].check_in_data.check_days.map((item, index) => {
        if (item.checked) {
          activeIndex = index;
        }
      });
      //设置显示的p_log index
      setPlogVisible(activeIndex);
    });
  };

  //获取是否首冲
  useEffect(() => {
    if (userInfo) {
      coins_data();
    }
  }, [userInfo]);

  //点击Check In按钮事件
  const onCoinsClick = () => {
    //判断是否登录
    if (!userInfo) {
      //跳转到注册页面
      history.push(ChannelRemind(`/login?${getPersist("last_phone") ? "" : "reg=1&"}`));
      return;
    }

    //todo 判断是否可以点击
    if (!coinsData["today_checkable"]) {
      //跳转到抽奖页面
      history.push(ChannelRemind("./luckyDraw"));
      return;
    }
    //请求接口签到，并根据返回结果响应改变展示效果
    coins_cmd();
  };

  return (
    <Dialog
      closeable={true}
      closeOnClickOverlay={true}
      width={"85%"}
      // closeIcon={<Close />}
      visible={props.coinsDiaLogVisible != 0}
      showCancelButton={false}
      className={style.coinsDialog}
      showConfirmButton={false}
      onClose={() => {
        props.setCoinsDiaLogVisible(false);
      }}
    >
      <div class={style.firstCoinsDialog}>
        <div style={{ width: "100%", height: "4rem" }}>
          <img style={{ width: "43%", marginTop: "1.2rem" }} src={require("@/assets/images/home/coins_title.png").default} />
        </div>
        <div class={style.firstCoinsSteps}>
          <div class={style.btntop}>
            {coinsData.check_days
              ? coinsData.check_days.map((item, index) => {
                  return (
                    <div key={index} class={style.checkactivebox} id={"index" + index}>
                      <div class={style.c_l}>
                        <div class={style.c_l_text}>
                          <span>+{item.award / 100}</span>
                        </div>
                        <div class={item.checked ? style.yuanbox_yes : style.yuanbox}>
                          {item.checked ? (
                            <sapn className={style.yuanbox_num}>
                              <img src={require("@/assets/images/home/coins_yes.png").default} style={{ width: "1rem" }} />
                            </sapn>
                          ) : (
                            <sapn className={style.yuanbox_num}>{index + 1}</sapn>
                          )}
                        </div>
                        <div class={style.tian}>Day {index + 1}</div>
                      </div>
                      <div>
                        {index === 3 || index === 6 ? (
                          <img alt="" />
                        ) : coinsData.check_days[index + 1].checked ? (
                          <img className={style.img_2} src={require("@/assets/images/home/coins_line2.png").default} alt="" />
                        ) : (
                          <img className={style.img_2} src={require("@/assets/images/home/coins_line.png").default} alt="" />
                        )}
                      </div>
                      <div class={`${style.p_log} ${pLogVisible == index ? style.p_log_active : ""}`}>
                        {" "}
                        Coins +{item.award / 100}
                      </div>
                    </div>
                  );
                })
              : null}
          </div>
        </div>
        <div class={style.firstCoinsBtn} onClick={onCoinsClick}>
          <div class={style.firstCoinsDialogBtnText}>
            {!userInfo ? (
              getPersist("last_phone")?(<span>Login</span>):(<span>REGISTER NOW</span>)
            ) : !coinsData.today_checkable ? (
              <span>Win Cash Gift</span>
            ) : (
              <span>Check In</span>
            )}
          </div>
        </div>
        <div class={style.coinsBottom}>
          <div class={style.coinsBottom_title}>Instructions</div>
          <div class={style.coinsBottom_content}>
            <span>.Check-in daily to claim up to 80 coins</span>
            <br />
            <span>.Check-in 7 days continuously to claim 300 coins</span>
            <br />
            <span>.Coins can only be used to win Cash Gift by playing Lucky Draw</span>
          </div>
        </div>
      </div>
    </Dialog>
  );
};

export default GetCoins;
